module.exports = __webpack_public_path__ + "img/lg_ring_r_o_1_1@3x.16592822.png";